function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from "react";
import { Form, InputNumber, Alert, Button } from 'antd';
import Common from "../includes/Common";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var AudioForm = function AudioForm(_ref) {
  var candidat = _ref.candidat,
    handler = _ref.handler;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormProcessing = _useState2[0],
    setIsFormProcessing = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    errorMessage = _useState4[0],
    setErrorMessage = _useState4[1];
  var onFinish = function onFinish(values) {
    setIsFormProcessing(true);
    axios.post(Common.baseApiUrl + 'processaudio', {
      hcright: values.hcright,
      hcleft: values.hcleft,
      cid: candidat.id,
      aid: Common.currentUser.id
    }).then(function (response) {
      if (response.data.status == 200) {
        handler();
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setErrorMessage('Une erreur est survenue');
    })["finally"](function () {
      setIsFormProcessing(false);
    });
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: "pad cool-radius",
      style: {
        background: '#FFDE08',
        padding: '10px'
      },
      children: /*#__PURE__*/_jsxs("p", {
        children: [/*#__PURE__*/_jsx("b", {
          children: "RNC : "
        }), candidat.rnc, /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("b", {
          children: "Pr\xE9nom: "
        }), candidat.firstname, /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("b", {
          children: "Nom: "
        }), candidat.lastname, /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("b", {
          children: "T\xE9l\xE9phone: "
        }), candidat.mobile, /*#__PURE__*/_jsx("br", {})]
      })
    }), /*#__PURE__*/_jsx("br", {}), errorMessage.length > 0 && /*#__PURE__*/_jsx(Alert, {
      type: "error",
      message: errorMessage,
      showIcon: true
    }), /*#__PURE__*/_jsxs(Form, {
      layout: "vertical",
      onFinish: onFinish,
      children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Form.Item, {
        name: "hcright",
        rules: [{
          required: true,
          message: 'Champs obligatoire'
        }],
        children: /*#__PURE__*/_jsx(InputNumber, {
          addonAfter: "CA Droit"
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "hcleft",
        rules: [{
          required: true,
          message: 'Champs obligatoire'
        }],
        children: /*#__PURE__*/_jsx(InputNumber, {
          addonAfter: "CA Gauche"
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Button, {
          type: "primary",
          loading: isFormProcessing,
          htmlType: "submit",
          children: "Sauvegarder"
        })
      })]
    })]
  });
};
export default AudioForm;